module.exports = __webpack_public_path__ + "static/media/background-dots.41801bd3.png";